<template>
  <div
    class="container"
    :class="{
      en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi',
    }"
  >
    <section class="main-block">
      <section class="main-tit">
        <div class="tit-des">{{ $t("terms.des") }}</div>
        <div class="tit-des-s" v-if="globalLang === 'en'">
          (user agreement, privacy policy)
        </div>
        <div class="tit-des-s" v-if="globalLang === 'th'">
          (ข้อตกลงผู้ใช้บัญชี นโยบายความเป็นส่วนตัว)
        </div>
        <span class="tit-slice"></span>
        <!-- <div class="tit-en-des" v-if="globalLang !== 'en'">REGULATIONS</div> -->
        <div class="tit-en-des" v-if="$area !== 'komoe-sea'">{{ $t('terms.enDes') }}</div>
      </section>
      <en v-if="globalLang === 'en'"></en>
      <zh v-if="globalLang === 'zh'"></zh>
      <cn v-if="globalLang === 'cn'"></cn>
      <ths v-if="globalLang === 'th'"></ths>
      <vi v-if="globalLang === 'vi'"></vi>
    </section>
  </div>
</template>

<script>
import en from "./en.vue";
import zh from "./zh.vue";
import cn from "./cn.vue";
import vi from "./vi.vue";
import ths from "./th.vue";
export default {
  components: {
    en,
    zh,
    cn,
    vi,
    ths,
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.container {
  position: relative;
  margin: 0 auto;
  padding: 0.48rem 0.12rem;
  min-height: calc(100vh - 1.32rem);
  box-sizing: border-box;
  font-size: 0.16rem;
  -webkit-font-smoothing: antialiased;
  &.en {
    .main-tit {
      border: none;
    }
    .tit-des {
      font-weight: bold;
    }
  }
}
.container.mgt_108 {
  padding-top: 1.28rem;
}
.container.mgt_48 {
  padding-top: 1.68rem;
}
.main-block {
  font-size: 0.2rem;
}

.main-tit {
  padding-top: 8.9%;
  text-align: center;
  border-bottom: 1px solid #ccc;
  .tit-des-s {
  }
}

.main-tit .tit-slice {
  width: 24px;
  height: 4px;
  background: #2da2d4;
  border-radius: 100px;
  vertical-align: middle;
  font-size: 0.16rem;
}

.main-tit .tit-en-des {
  padding-bottom: 3.5%;
  font-size: 0.1rem;
  color: #cccccc;
  letter-spacing: 0;
  line-height: 17px;
}

.main-tit .tit-des {
  font-size: 0.2rem;
  color: #444444;
  letter-spacing: 0;
}

.main-tit span {
  display: inline-block;
}
</style>
